import type { ReactNode } from "react";

import { Label } from "@/components/ui/label";

/** A label, a control, and an optional hint beneath, stacked. */
export function Field({
  id,
  label,
  hint,
  children,
  required,
}: {
  id: string;
  label: string;
  hint?: ReactNode;
  children: ReactNode;
  required?: boolean;
}) {
  return (
    <div className="grid gap-2">
      <Label htmlFor={id}>
        {label}
        {required ? <span className="text-destructive"> *</span> : null}
      </Label>
      {children}
      {hint ? <p className="text-muted-foreground text-xs">{hint}</p> : null}
    </div>
  );
}
